var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconBellFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0c-2.207 0-4 1.793-4 4s1.793 4 4 4 4-1.793 4-4-1.793-4-4-4zm-5.625 6.094C14.805 8.05 12 12.457 12 18c0 11-3.8 13.762-6.063 15.406C4.934 34.133 4 34.81 4 36c0 4.207 6.281 6 21 6 14.719 0 21-1.793 21-6 0-1.191-.934-1.867-1.938-2.594C41.801 31.762 38 29 38 18c0-5.559-2.8-9.953-7.375-11.906C29.77 8.367 27.566 10 25 10s-4.77-1.637-5.625-3.906zM19 43.875V44c0 3.309 2.691 6 6 6s6-2.691 6-6v-.125a144.552 144.552 0 01-12 0z"
  })));
}

export default SvgCommonIconBellFilled;